import React from "react";
import { Box, Chip, Typography, useTheme } from "@mui/material";
import { Crown } from "lucide-react";
import { AssessmentLeaderboardItem } from "../../../axios/quiz";
import { useAuthStore } from "../../../stores/authStore";
import useUserStore from "../../../stores/userStore";
import { getAssessmentUserPlace } from "../assessment-contest-utils";
import {
  containerStyle,
  contestTitleStyle,
  rankChipStyle,
  rightSideStyle,
  titleBlockStyle,
  titleStyle,
} from "./styles";

interface AssessmentContestTopBarProps {
  contestTitle?: string | null;
  currentUserPlace?: number | null;
  leaderboard?: AssessmentLeaderboardItem[];
  actions?: React.ReactNode;
  gamificationEnabled?: boolean;
}

export const AssessmentContestTopBar = ({
  contestTitle = null,
  currentUserPlace,
  leaderboard = [],
  actions,
  gamificationEnabled = true,
}: AssessmentContestTopBarProps) => {
  const theme = useTheme();
  const authUserId = useAuthStore((state) => state.userId);
  const storedUserId = useUserStore((state) => state.user.id);
  const currentUserId = storedUserId || authUserId || null;
  const resolvedCurrentUserPlace = getAssessmentUserPlace(
    leaderboard,
    currentUserId,
    currentUserPlace ?? null
  );
  const resolvedContestTitle =
    typeof contestTitle === "string" && contestTitle.trim()
      ? contestTitle.trim()
      : null;

  return (
    <Box sx={containerStyle}>
      <Box sx={titleBlockStyle}>
        <Typography sx={titleStyle}>TAP Knowledge Challenge 🏆</Typography>
        {resolvedContestTitle ? (
          <Typography
            sx={contestTitleStyle}
            title={resolvedContestTitle}
            noWrap
          >
            {resolvedContestTitle}
          </Typography>
        ) : null}
      </Box>
      <Box sx={rightSideStyle}>
        {gamificationEnabled && resolvedCurrentUserPlace ? (
          <Chip
            icon={<Crown size={16} />}
            label={`Rank #${resolvedCurrentUserPlace}`}
            sx={rankChipStyle(theme)}
          />
        ) : null}
        {actions}
      </Box>
    </Box>
  );
};

export default AssessmentContestTopBar;
